const BannerLang = {
    init() {
        const bannerLang = $('.js-banner-lang');
        const headerMenu = $('#main-header');
        const mainContent = $('#main_content');
        const showModalBtn = $('.display-modal');
        const closeModalBtn = $('.popup-lang__close');
        const popupLang = $('.js-popup-lang');
        const popupBackdrop = $('.popup-backdrop');
        const bannerClose = $('.js-banner-lang__close');
        const popupLanguagesList = popupLang.find('.js-lang-item .lang');

        if (!!popupLanguagesList.length) {
            popupLanguagesList.each(function() {
                const languageName = $(this).text();
                const explodedLanguageName = languageName.split(' ');
                const languageCode = explodedLanguageName[explodedLanguageName.length - 1];
                const upperLanguageCode = languageCode.toUpperCase();
                explodedLanguageName.pop();
                explodedLanguageName.push(upperLanguageCode);
                $(this).text(explodedLanguageName.join(' '));
            });
        }

        if (!Cookies.get('close-banner-lang')) {
            if (!!bannerLang.length && !!headerMenu.length && !!mainContent.length) {
                const userLang = (navigator.language || navigator.userLanguage).toLowerCase();
                const languages = $('.js-lang-list .js-lang-item');
                //const activeLangElement = Array.prototype.filter.call(languages, item => $(item).data('active') === 'active');
                const langCodeList = Array.prototype.map.call(languages, item => $(item).data('code'));
                //const activeLang = Array.prototype.map.call(activeLangElement, item => $(item).data('code'))[0];
                const activeLang = bannerLang.data('lang');

                if (!BannerLang.checkBrowserEqualActiveLang(userLang, activeLang) && !!BannerLang.checkBrowserLangSupportedBySite(userLang, langCodeList).length) {
                    const userLangElement = Array.prototype.filter.call(languages, item => $(item).data('code') === BannerLang.checkBrowserLangSupportedBySite(userLang, langCodeList)[0]);
                    const activeElement = Array.prototype.filter.call(languages, item => $(item).data('code') === activeLang);
                    const selectedUrl = $(userLangElement[0]).find('.link').attr('href');

                    $(activeElement).css('display', 'none');
                    bannerLang.outerHeight('auto');
                    bannerLang.addClass('active');
                    $('.js-banner-lang .switch-lang').attr('href', selectedUrl);
                }

                showModalBtn.on('click', function() {
                    BannerLang.triggerPopupLang(popupLang, popupBackdrop);
                });

                closeModalBtn.on('click', function() {
                    BannerLang.hidePopupLang(popupLang, popupBackdrop);
                });

                bannerClose.on('click', function() {
                    Cookies.set('close-banner-lang', true);
                    bannerLang.outerHeight('0px');
                    bannerLang.removeClass('active');
                });
            }
        }
    },

    triggerPopupLang(popup, backdrop) {
        popup.addClass('open');
        $('body').addClass('prevent-scroll');
        backdrop.addClass('show');
    },

    hidePopupLang(popup, backdrop) {
        popup.removeClass('open');
        $('body').removeClass('prevent-scroll');
        backdrop.removeClass('show');
    },

    checkBrowserEqualActiveLang(browserLang, activeLang) {
        const isBrowserCodeLong = browserLang.includes('-');
        const isActiveCodeLong = activeLang.includes('-');

        if ((isBrowserCodeLong && isActiveCodeLong) || (!isBrowserCodeLong && !isActiveCodeLong)) {
            return browserLang === activeLang;
        }
        if (isBrowserCodeLong && !isActiveCodeLong) {
            const concatActiveLang = activeLang + '-' + activeLang;
            return concatActiveLang === browserLang;
        }
    },

    checkBrowserLangSupportedBySite(browserLang, langSiteList) {
        let supportedLang = langSiteList.filter(lang => lang === browserLang);
        if (!!(!supportedLang.length)) {
            if (!browserLang.includes('-')) {
                const concatBrowserLang = `${browserLang}-${browserLang}`;
                supportedLang = langSiteList.filter(lang => lang === concatBrowserLang);
            } else {
                supportedLang = langSiteList.filter(lang => lang.includes(browserLang.slice(0, 2)));
            }
        }

        return supportedLang;
    },
};

export default BannerLang;
